import * as d3 from "d3";
import {
    colonAnnotation,
    contextMenu,
    createAxis, createTooltip,
    generateDownloadData,
    numberFormat
} from '../functions'

export default function (chart, divId, vizName, resData, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"

    console.log("Chart vizName called:", chart, vizName, filterParam)

    let data = resData
    console.log("data",data)
    var barWidth = 100  // Hardcoded width per x-axis group
    var totalWidth = data.length * barWidth

    // Scales
    var x1Scale = createAxis(chart.x1D3ScaleType)
        .domain(data.map(d => d.dim1_name))
        .range([0, totalWidth])
        .padding(0.1)

    var x2Scale = createAxis(chart.x2D3ScaleType).rangeRound([chart.height, 0])
    var y1Scale = createAxis(chart.y1D3ScaleType).range([chart.height, 0])

    var metric1ColorScale = d3.scaleOrdinal().range(chart.vizSpecific7.colorScheme)

    var x1AxisLabel = d3.axisBottom(x1Scale)
    var y1AxisLabel = d3.axisLeft(y1Scale).tickFormat(numberFormat)

    d3.select(divId).select("svg").remove()
    d3.select(divId).select('.chart-scroll-wrapper').remove()

    const scrollWrapper = d3.select(divId)
        .append('div')
        .attr('class', 'chart-scroll-wrapper')
        .style('overflow-x', 'auto')
        .style('width', '100%')
        .style('position', 'relative');

    // Y-axis container (fixed)
    const yAxisContainer = d3.select(divId)
        .append('div')
        .attr('class', 'y-axis-container')
        .style('position', 'absolute')
        .style('top', chart.margin.top + chart.margin.bottom+ 20 + 'px')
        .style('left', '0px')
        .style('height', (chart.height) + 'px')
        .style('width', (chart.margin.left) + 'px')
        .style('background', '#fff')
        .style('z-index', 2);

    const svg = scrollWrapper.append('svg')
        .attr('width', totalWidth + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + 3 * chart.margin.top + 3 * chart.margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')');

    var categories = d3.keys(data[0]).filter(key =>
        ['metric1', 'metric2', 'metric3', 'metric4', 'metric5'].includes(key)
    )

    data.forEach(function (d) {
        let total = 0
        let totals = {}
        for (var i = 0; i < categories.length; i++) {
            if (i >= chart.vizSpecific1) {
                total = total - +d[categories[i]]
                totals[categories[i]] = total
            } else {
                totals[categories[i]] = total
                total += +d[categories[i]]
            }
        }

        d.formatted = categories.map(category => ({
            name: category,
            value: +d[category],
            baseHeight: +totals[category]
        }))
    })

    x2Scale.domain(categories).range([0, x1Scale.bandwidth()])
    y1Scale.domain([0, d3.max(data, d =>
        d3.max(d.formatted, d => d.value + d.baseHeight)
    )])

    // Render static Y-axis
    yAxisContainer.append('svg')
        .attr('width', chart.margin.left)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + (chart.margin.left - 1) + ',' + (0)+')')
        .call(y1AxisLabel)
        .selectAll('text')
        .style('font-size', axisLabelFontSize);

    const tooltip = createTooltip(divId);

    svg.append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + chart.height + ')')
        .call(x1AxisLabel)
        .selectAll('.x.axis .tick line')
        .attr('transform', 'translate(' + x1Scale.bandwidth() / 2 + ')')
        .attr('stroke', 0.3);

    svg.selectAll('text')
        .style('font-size', axisLabelFontSize)
        .style('text-anchor', 'middle')
        .attr('transform', 'rotate(-50)')
        .attr('dx', '-2.5em')
        .attr('dy', '-0.4em');

    svg.append('text')
        .attr('x', (chart.width / 3))
        .attr('y', chart.height + 3 * chart.margin.bottom + 8 * chart.axisLabelDistance)
        .style('fill', fontColor)
        .text(chart.x1AxisDisplayName)
        .style('font-size', fontSize);

    svg.append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - chart.margin.left + chart.axisLabelDistance)
        .attr('x', 0 - (chart.height / 2))
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .style('fill', fontColor)
        .text(chart.y1AxisDisplayName)
        .style('font-size', fontSize);

    var state = svg.selectAll('.state')
        .data(data)
        .enter().append('g')
        .attr('class', 'g')
        .attr('transform', d => 'translate(' + x1Scale(d.dim1_name) + ',0)');

    state.selectAll('rect')
        .data(d => d.formatted)
        .enter().append('rect')
        .attr('width', x2Scale.bandwidth())
        .attr('x', d => x2Scale(d.name))
        .attr('y', d => y1Scale(d.value + d.baseHeight))
        .attr('height', d => chart.height - y1Scale(d.value))
        .style('fill', d => metric1ColorScale(d.name))
        .on('mouseover', function (d) {
            tooltip.onMouseOver(d, this, d =>
                d.name == "metric1" ? chart.vizSpecific5 + colonAnnotation + numberFormat(d.value) :
                    d.name == "metric2" ? chart.x1DataFieldName + colonAnnotation + numberFormat(d.value) :
                        d.name == "metric3" ? chart.x2DataFieldName + colonAnnotation + numberFormat(d.value) :
                            d.name == "metric4" ? chart.y1DataFieldName + colonAnnotation + numberFormat(d.value) :
                                d.name == "metric5" ? chart.y2DataFieldName + colonAnnotation + numberFormat(d.value) :
                                    null + colonAnnotation + d.value);
        })
        .on('mousemove', function (event) {
            tooltip.onMouseMove(event);
        })
        .on('mouseout', function () {
            tooltip.onMouseLeave();
        })
        .on('contextmenu', function () {
            const parentData = d3.select(this.parentNode).datum();
            const clickedData = {
                [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [parentData.dim1_name]
            };
            const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
            contextMenu(menuItems).call(this, clickedData);
            d3.event.preventDefault();
        });

    state.append("line")
        .attr("class", "bar_separater")
        .attr("x1", (x1Scale.step() - x1Scale.bandwidth()) * 0 + x1Scale.bandwidth())
        .attr("x2", (x1Scale.step() - x1Scale.bandwidth()) * 0 + x1Scale.bandwidth())
        .attr("y1", 0)
        .attr("y2", chart.height + (chart.margin.bottom / 2))
        .style("stroke-width", 0.3)
        .style("stroke", "#000");

    var toggle = true;

    d3.select("#" + divId.id + "grid").on("click", function gridToggle() {
        d3.selectAll("line").style("opacity", +(toggle = !toggle))
    });

    var y1legend = svg.selectAll('.legend')
        .data(categories)
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', (d, i) => 'translate(' + (180 * i) + ',6)');

    y1legend.append('rect')
        .attr('x', (chart.width / 7))
        .attr('y', chart.height + 2 * chart.margin.bottom)
        .attr('width', 20)
        .attr('height', 20)
        .style('fill', metric1ColorScale);

    y1legend.append('text')
        .attr('x', (chart.width / 7) + 20)
        .attr('y', chart.height + 2 * chart.margin.bottom)
        .attr('dy', '1em')
        .style('font-size', '14px')
        .text(d => d == "metric1" ? chart.vizSpecific5 :
            d == "metric2" ? chart.x1DataFieldName :
                d == "metric3" ? chart.x2DataFieldName :
                    d == "metric4" ? chart.y1DataFieldName :
                        d == "metric5" ? chart.y2DataFieldName : null);
}
